import { useEffect, useState } from "react";
import { Check, Plus, UserX, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const statusOf = (u) => (u.status === "pending" ? ["Menunggu persetujuan", "waiting"] : u.active ? ["Aktif", "verified"] : u.auth === "google" ? ["Ditolak", "rejected"] : ["Nonaktif", "rejected"]);

const AddUser = ({ close, saved }) => {
  const [f, setF] = useState({ email: "", name: "", role: "operator" });
  const submit = async (e) => {
    e.preventDefault();
    try { await api("/users", { method: "POST", body: JSON.stringify(f) }); toast.success("Email Google didaftarkan"); saved(); close(); }
    catch (err) { toast.error(err.message); }
  };
  return (
    <div className="modal-backdrop"><div className="modal">
      <div className="modal-head"><h3>Daftarkan email Google</h3><button onClick={close} data-testid="add-user-close-button"><X size={18} /></button></div>
      <form className="modal-form" onSubmit={submit}>
        <label>Email Google<input type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="add-user-email-input" /></label>
        <label>Nama<input required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="add-user-name-input" /></label>
        <label>Peran<select value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })} data-testid="add-user-role-select"><option value="operator">Operator</option><option value="admin">Admin</option></select></label>
        <button className="primary-btn full" data-testid="add-user-submit-button">Simpan</button>
      </form>
    </div></div>
  );
};

const EmailCell = ({ u, patch }) => {
  const [v, setV] = useState(u.email || "");
  if (u.auth === "google") return <span>{u.email}</span>;
  return <input className="inline-input" placeholder="Tautkan email Google…" value={v} onChange={(e) => setV(e.target.value)} onBlur={() => v !== (u.email || "") && v && patch(u.id, { email: v })} data-testid={`user-email-input-${u.id}`} />;
};

export const UsersPage = ({ me }) => {
  const [rows, setRows] = useState([]);
  const [show, setShow] = useState(false);
  const load = () => api("/users").then(setRows).catch((e) => toast.error(e.message));
  useEffect(() => { load(); }, []);
  const patch = async (id, body, msg = "Pengguna diperbarui") => {
    try { await api(`/users/${id}`, { method: "PATCH", body: JSON.stringify(body) }); toast.success(msg); load(); }
    catch (e) { toast.error(e.message); }
  };
  const pending = rows.filter((u) => u.status === "pending").length;
  return (
    <div data-testid="users-page">
      <div className="page-heading compact">
        <div><p className="eyebrow">MANAJEMEN AKSES</p><h1>Pengguna</h1><p className="muted">Kelola akun, peran, dan permintaan akses masuk dengan Google.</p></div>
        <button className="primary-btn" onClick={() => setShow(true)} data-testid="add-user-button"><Plus size={17} /> Daftarkan email Google</button>
      </div>
      {pending > 0 && <div className="notice-bar" data-testid="pending-users-notice">{pending} permintaan akses menunggu persetujuan Anda.</div>}
      <section className="panel table-panel">
        <table><thead><tr><th>Pengguna</th><th>Email Google</th><th>Metode</th><th>Peran</th><th>Status</th><th>Aksi</th></tr></thead>
          <tbody>{rows.map((u) => {
            const [label, cls] = statusOf(u); const self = u.id === me.id;
            return (
              <tr key={u.id} data-testid={`user-row-${u.id}`}>
                <td><b>{u.name}</b><small className="table-sub">@{u.username}</small></td>
                <td><EmailCell u={u} patch={patch} /></td>
                <td>{u.auth === "google" ? "Google" : "Password"}</td>
                <td><select className="inline-input" value={u.role} disabled={self} onChange={(e) => patch(u.id, { role: e.target.value })} data-testid={`user-role-select-${u.id}`}><option value="operator">Operator</option><option value="admin">Admin</option></select></td>
                <td><span className={`status ${cls}`} data-testid={`user-status-${u.id}`}>{label}</span></td>
                <td className="row-actions">
                  {u.status === "pending" || u.status === "rejected" || !u.active ? (
                    <button className="mini-btn ok" onClick={() => patch(u.id, { status: "active" }, "Akses disetujui")} data-testid={`user-approve-button-${u.id}`}><Check size={14} /> Setujui</button>
                  ) : null}
                  {!self && u.status !== "rejected" && (u.active || u.status === "pending") ? (
                    <button className="mini-btn danger" onClick={() => patch(u.id, { status: "rejected" }, "Akses ditolak")} data-testid={`user-reject-button-${u.id}`}><UserX size={14} /> {u.status === "pending" ? "Tolak" : "Nonaktifkan"}</button>
                  ) : null}
                </td>
              </tr>);
          })}</tbody></table>
      </section>
      {show && <AddUser close={() => setShow(false)} saved={load} />}
    </div>
  );
};
